import styled, { css } from 'styled-components';

export const Td = styled.td<{
  clip?: boolean;
  center?: boolean;
  right?: boolean;
  top?: boolean;
  valign?: 'top' | 'middle' | 'bottom';
  clickable?: boolean;
}>`
  ${({ clip }) =>
    clip &&
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    `}

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}

    ${({ right }) =>
    right &&
    css`
        text-align: right;
      `}

    ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

    ${({ top }) =>
    top &&
    css`
      vertical-align: top;
    `}

    ${({ valign }) => {
    if (!valign) {
      return '';
    }
    const alignMap = { top: 'flex-start', middle: 'center', bottom: 'flex-end' };
    return css`
      display: flex;
      align-items: ${alignMap[valign]};
    `;
    }}

    &.removed {
    text-decoration: line-through;
  }

  &.disabled {
    pointer-events: none;
    cursor: default;
  }
`;
